(() => {
	window.addEventListener('load', function () {
		const costCalculatorExp = {
			costCalculatorWithLeadForm() {
				/* eslint-disable-next-line no-undef */
				HVAC.formCentral.createMultiStep({
					placement: '#costCalculatorForm',
					formKey: 'costCalculator',
					formName: 'COST_CALCULATOR',
					formType: 'LEAD',
					companyId: 'disabled',
					tcpa: 'By submitting this form, you are giving your express written consent to be contacted at the phone number you inputted (including your wireless if provided) for the purpose of home improvement requests & contractor bids. You understand that automated technology will be used to call and text and that consent is not requirement to purchase. You may also call <a href="tel: 855-335-1188"> 855-335-1188</a>.',
					payloadData: {
						brand: 'FURNACE_COMPARE',
						kind: 'CONTACT_DEALER',
						source: 'FURNACE_COMPARE:EMAIL_FORM',
					},
					progressBar: {
						showSteps: false,
					},
					steps: [
						{
							stepId: 'systemType',
							title: 'What type of system do you need?',
							inputs: [
								{
									label: 'What type of system do you need?',
									name: 'systemType',
									type: 'button-group',
									buttons: [
										{
											name: 'Furnace',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'FURNACE',
												formStarted: true,
											},
										},
										{
											name: 'Air Conditioner',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'AIR CONDITIONER',
												formStarted: true,
											},
										},
										{
											name: 'Heat Pump',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'HEAT PUMP',
												formStarted: true,
											},
										},
									],
									track: {
										fieldLabel: 'System Type',
										fieldType: 'BUTTON',
										stepNumber: 1,
										stepName: 'SYSTEM TYPE',
									},
									validation: [
										{ type: 'required', value: 'Input is required' },
									],
								}],
							btnControlText: ['Next', 'Back'],
						},
						{
							stepId: 'homeSize',
							title: 'What size house do you have?',
							inputs: [
								{
									buttons: [
										{
											name: 'Less than 1,000 ft²',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'SMALL HOME',
											},
										},
										{
											name: '1,000 to 2,000 ft²',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'MEDIUM HOME',
											},
										},
										{
											name: '2,000 to 3,000 ft²',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'LARGE HOME',
											},
										},
										{
											name: 'More than 3,000 ft²',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'XLARGE HOME',
											},
										},
									],
									label: 'How big is your home?',
									name: 'homeSize',
									type: 'button-group',
									track: {
										fieldLabel: 'Home Size',
										fieldType: 'BUTTON',
										stepNumber: 2,
										stepName: 'HOME SIZE',
									},
									validation: [
										{ type: 'required', value: 'Input is required' },
									],
								}],
							btnControlText: ['Next', 'Back'],
						},
						{
							stepId: 'hvacFeatures',
							title: 'What are you looking for in your HVAC unit?',
							inputs: [
								{
									label: 'What are you looking for in your HVAC unit?',
									name: 'hvacFeatures',
									type: 'button-group',
									buttons: [
										{
											name: 'Energy Efficiency',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'ENERGY EFFICIENCY',
											},
										},
										{
											name: 'Quiet Operation',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'QUIET OPERATION',
											},
										},
										{
											name: 'Value',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'VALUE',
											},
										},
									],
									track: {
										fieldLabel: 'System Type',
										fieldType: 'BUTTON',
										stepNumber: 3,
										stepName: 'SYSTEM TYPE',
									},
									validation: [
										{ type: 'required', value: 'Input is required' },
									],
								}],
							btnControlText: ['Next', 'Back'],
						},
						{
							stepId: 'multiZipcode',
							title: 'What is your ZIP code?',
							description: 'This helps us match you with a top-rated pro in your area.',
							btnControlText: ['Next', 'Back'],
							inputs: [
								{
									label: 'ZIP Code',
									name: 'zip',
									type: 'text',
									track: {
										fieldLabel: 'Zip Code',
										fieldType: 'ZIPCODE',
										stepNumber: 4,
										stepName: 'ZIPCODE',
									},
									validation: [
										{ type: 'required', value: 'Input is required' },
										{ type: 'zip', value: 'Zip code is invalid' },
									],
								},
							],
						},
						{
							stepId: 'multiLead',
							title: 'What is your contact information?',
							description: 'This lets us tell your heating and cooling expert who to contact to schedule an appointment. Click submit below to connect with a certified local HVAC contractor!',
							note: 'By entering your phone number and clicking the "Submit" button below, I agree to the following:<ul><li>I am providing my prior express written consent to share my information with FurnaceCompare.com\'s, Networx, and Networx\'s authorized parties calling on their behalf, to deliver calls or text messages to my phone number provided above, for the purpose of home improvement requests & contractor bids, using an automated telephone dialing system or an artificial or prerecorded voice. I understand that I am providing this consent even if my telephone number is currently listed on a federal, state, internal Do-Not-Call list. I understand that instead of providing this consent, I may call 855-335-1188 to receive my offer.</li><li>I understand that I do not have to agree to receive these types of calls or text messages as a condition for purchasing any goods or services, and that message and data rates may apply.</li><li>www.www.bluezima.com\'s <a href="/privacy">Privacy Policy</a> and <a href="/terms">Terms of Use</a>.</li></ul>',
							btnControlText: [ 'Submit', 'Back' ],
							inputs: [
								{
									label: 'First Name',
									name: 'firstName',
									type: 'text',
									track: {
										fieldLabel: 'First Name',
										fieldType: 'FIRST NAME',
										stepNumber: 5,
										stepName: 'FIRST NAME',
									},
									validation: [
										{ type: 'required', value: 'Input is required' },
									],
								},
								{
									label: 'Last Name',
									name: 'lastName',
									type: 'text',
									track: {
										fieldLabel: 'Last Name',
										fieldType: 'LAST NAME',
										stepName: 'LAST NAME',
									},
									validation: [
										{ type: 'required', value: 'Input is required' },
									],
								},
								{
									label: 'Email address',
									name: 'email',
									type: 'text',
									track: {
										fieldLabel: 'Email',
										fieldType: 'EMAIL',
									},
									validation: [
										{ type: 'required', value: 'Email is required' },
										{ type: 'email', value: 'Email is invalid' },
									],
								},
								{
									label: 'Phone number',
									name: 'phone',
									type: 'text',
									track: {
										fieldLabel: 'Phone',
										fieldType: 'PHONE',
									},
									validation: [
										{ type: 'required', value: 'Phone number is required' },
										{ type: 'phone', value: 'Phone number is invalid' },
									],
								},
							],
						},
					],
					success: {
						iconClassName: '',
						message: 'Take a look at our reliable heating and cooling products to see what system works best for you.',
						subTitle: 'Thanks! We\'ve found a local dealer who can help. {{dealer}}  will contact you shortly.',
						title: 'YOU\'RE ALL SET',
						buttons: [
							{
								name: 'Button 1',
								track: {
									fieldLabel: 'Confirm Appointment',
									fieldType: 'BUTTON',
								},
								url: '/page-1',
							},
							{
								name: 'Button 2',
								track: {
									fieldLabel: 'Confirm Appointment',
									fieldType: 'BUTTON',
								},
								url: '/page-2',
							},
						],
					},
					error: {
						iconClassName: '',
						title: 'SOMETHING WENT WRONG',
						subTitle: 'Ooops! Something went wrong!',
						message: 'Please try again.',
						buttons: [
							{
								name: 'Button 1',
								track: {
									fieldLabel: 'Button 1',
									fieldType: 'BUTTON',
								},
								url: '/page-1',
							},
						],
					},
				});
			},

			costCalculatorNoLeadForm() {
				/* eslint-disable-next-line no-undef */
				HVAC.formCentral.createMultiStep({
					placement: '#costCalculatorForm',
					formKey: 'costCalculator',
					formName: 'COST_CALCULATOR',
					formType: 'LEAD',
					companyId: 'disabled',
					payloadData: {
						brand: 'FURNACE_COMPARE',
						kind: 'CONTACT_DEALER',
						source: 'FURNACE_COMPARE:EMAIL_FORM',
					},
					progressBar: {
						showSteps: false,
					},
					steps: [
						{
							stepId: 'systemType',
							title: 'What type of system do you need?',
							inputs: [
								{
									label: 'What type of system do you need?',
									name: 'systemType',
									type: 'button-group',
									buttons: [
										{
											name: 'Furnace',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'FURNACE',
											},
										},
										{
											name: 'Air Conditioner',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'AIR CONDITIONER',
											},
										},
										{
											name: 'Heat Pump',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'HEAT PUMP',
											},
										},
									],
									track: {
										fieldLabel: 'System Type',
										fieldType: 'BUTTON',
										stepNumber: 1,
										stepName: 'SYSTEM TYPE',
									},
									validation: [
										{ type: 'required', value: 'Input is required' },
									],
								}],
							btnControlText: ['Next', 'Back'],
						},
						{
							stepId: 'homeSize',
							title: 'What size house do you have?',
							inputs: [
								{
									buttons: [
										{
											name: 'Less than 1,000 ft²',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'SMALL HOME',
											},
										},
										{
											name: '1,000 to 2,000 ft²',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'MEDIUM HOME',
											},
										},
										{
											name: '2,000 to 3,000 ft²',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'LARGE HOME',
											},
										},
										{
											name: 'More than 3,000 ft²',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'XLARGE HOME',
											},
										},
									],
									label: 'How big is your home?',
									name: 'homeSize',
									type: 'button-group',
									track: {
										fieldLabel: 'Home Size',
										fieldType: 'BUTTON',
										stepNumber: 2,
										stepName: 'HOME SIZE',
									},
									validation: [
										{ type: 'required', value: 'Input is required' },
									],
								}],
							btnControlText: ['Next', 'Back'],
						},
						{
							stepId: 'hvacFeatures',
							title: 'What are you looking for in your HVAC unit?',
							btnControlText: ['Submit', 'Back'],
							inputs: [
								{
									label: 'What are you looking for in your HVAC unit?',
									name: 'hvacFeatures',
									type: 'button-group',
									buttons: [
										{
											name: 'Energy Efficiency',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'ENERGY EFFICIENCY',
											},
										},
										{
											name: 'Quiet Operation',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'QUIET OPERATION',
											},
										},
										{
											name: 'Value',
											track: {
												actionOutcome: 'GROUPSELECTION', // made up
												elementType: 'BUTTON',
												location: 'COST CALCULATOR',
												text: 'VALUE',
											},
										},
									],
									track: {
										fieldLabel: 'System Type',
										fieldType: 'BUTTON',
										stepNumber: 3,
										stepName: 'SYSTEM TYPE',
									},
									validation: [
										{ type: 'required', value: 'Input is required' },
									],
								}],
						},
					],
					onSubmit: {
						callback(data) {
							costCalculatorExp.processCostCalculatorData(data);
							const msgTitleStr = 'Your email has already been sent to a local professional.';
							const msgStr = 'Thank you for letting FurnaceCompare.com connect you with a certified contractor. A local specialist will contact you shortly.';
							document.querySelector('.result-status').classList.add('result-status--success');
							document.querySelector('.result-status').classList.remove('result-status--failure');
							document.querySelector('.result-status').innerHTML = msgTitleStr;
							document.querySelector('.cost-calculator__result-split--bg-gray p.biline').innerHTML = msgStr;
							document.querySelector('#costCalculatorForm').classList.add('hide');
							document.querySelector('#costCalculatorForm').style.display = 'none';
							document.querySelector('#costCalculatorFinalResult').classList.remove('hide-off-screen');
							if (document.querySelector('.cost-calculator--acf .cost-calculator__choice-tracker')) {
								document.querySelector('.cost-calculator--acf .cost-calculator__choice-tracker').classList.add('hide');
							}
							tagularCostCalcCompletion();
						},
					},
					success: {
						iconClassName: '',
						message: 'Take a look at our reliable heating and cooling products to see what system works best for you.',
						subTitle: 'Thanks! We\'ve found a local dealer who can help. {{dealer}}  will contact you shortly.',
						title: 'YOU\'RE ALL SET',
						buttons: [
							{
								name: 'Button 1',
								track: {
									fieldLabel: 'Confirm Appointment',
									fieldType: 'BUTTON',
								},
								url: '/page-1',
							},
							{
								name: 'Button 2',
								track: {
									fieldLabel: 'Confirm Appointment',
									fieldType: 'BUTTON',
								},
								url: '/page-2',
							},
						],
					},
					error: {
						iconClassName: '',
						title: 'SOMETHING WENT WRONG',
						subTitle: 'Ooops! Something went wrong!',
						message: 'Please try again.',
						buttons: [
							{
								name: 'Button 1',
								track: {
									fieldLabel: 'Button 1',
									fieldType: 'BUTTON',
								},
								url: '/page-1',
							},
						],
					},
				});
			},

			onMultiStepLeadFormSubmit() {
				document.addEventListener('HVACFormSubmit', (event) => {
					const data = window.HVAC.formList.costCalculator.values;
					let msgTitleStr = '';
					let msgStr = '';
					if (event.detail.success === true) {
						costCalculatorExp.processCostCalculatorData(data);
						msgTitleStr = 'Thank you!';
						msgStr = 'Thank you for letting www.bluezima.com connect you with a certified contractor. A local specialist will contact you shortly.';
						document.querySelector('.result-status').classList.add('result-status--success');
						document.querySelector('.result-status').classList.remove('result-status--failure');
					} else {
						costCalculatorExp.processCostCalculatorData(data);
						msgTitleStr = 'Your email failed to send!';
						msgStr = 'We encountered an error while sending your information to a certified contractor. Please click the button below to start over.';
						document.querySelector('.result-status').classList.remove('result-status--success');
						document.querySelector('.result-status').classList.add('result-status--failure');
					}
					if (document.querySelector('.cost-calculator--acf .cost-calculator__choice-tracker')) {
						document.querySelector('.cost-calculator--acf .cost-calculator__choice-tracker').classList.add('hide');
					}
					document.querySelector('.result-status').innerHTML = msgTitleStr;
					document.querySelector('.cost-calculator__result-split--bg-gray p.biline').innerHTML = msgStr;
					document.querySelector('#costCalculatorForm').classList.add('hide');
					document.querySelector('#costCalculatorFinalResult').classList.remove('hide-off-screen');
					tagularCostCalcCompletion();
				});
			},

			getSystemCost(systemType, sqFt) {
				let systemCost = '';
				if (systemType === 'Furnace') {
					if (sqFt === 'Less than 1,000 ft²') {
						systemCost = '$1,683 - $3,740';
					}
					if (sqFt === '1,000 to 2,000 ft²') {
						systemCost = '$2,921 - $4,739';
					}
					if (sqFt === '2,000 to 3,000 ft²') {
						systemCost = '$3,163 - $5,723';
					}
					if (sqFt === 'More than 3,000 ft²') {
						systemCost = '$3,826 - $5,738';
					}
				}
				if (systemType === 'Air Conditioner') {
					if (sqFt === 'Less than 1,000 ft²') {
						systemCost = '$1,616 - $3,863';
					}
					if (sqFt === '1,000 to 2,000 ft²') {
						systemCost = '$3,132 - $5,560';
					}
					if (sqFt === '2,000 to 3,000 ft²') {
						systemCost = '$3,970 - $6,510';
					}
					if (sqFt === 'More than 3,000 ft²') {
						systemCost = '$4,463 - $6,694';
					}
				}
				if (systemType === 'Heat Pump') {
					if (sqFt === 'Less than 1,000 ft²') {
						systemCost = '$3,771 - $8,056';
					}
					if (sqFt === '1,000 to 2,000 ft²') {
						systemCost = '$4,371 - $9,116';
					}
					if (sqFt === '2,000 to 3,000 ft²') {
						systemCost = '$4,959 - $10,679';
					}
					if (sqFt === 'More than 3,000 ft²') {
						systemCost = '$5,881 - $13,981';
					}
				}
				return systemCost;
			},

			processCostCalculatorData(data) {
				const calculatedSystemEstimate = costCalculatorExp.getSystemCost(data.systemType.value, data.homeSize.value);
				if (!document.querySelector('.cost-calculator--acf')) {
					const subheadEstimateResultStr = ('Your FurnaceCompare.com estimate is ').concat(calculatedSystemEstimate).concat('.*');
					document.getElementById('subheadEstimateResult').innerHTML = subheadEstimateResultStr;
					document.querySelector('.cost-calculator__disclaimer').classList.remove('hide');
				}
				document.getElementById('systemEstimate').innerHTML = calculatedSystemEstimate;
			},
		};

		// Initialize cost calculator multistep form
		function initForm() {
			costCalculatorExp.costCalculatorWithLeadForm();
			costCalculatorExp.onMultiStepLeadFormSubmit();
		}
		initForm();

		function tagularCostCalcCompletion() {
			if (typeof window.tagular !== 'function') {
				return;
			}
			window.tagular('beam', {
				'@type': 'redventures.usertracking.v3.ElementViewed',
				webElement: {
					location: 'COST_CALCULATOR',
					position: 'COST_CALCULATOR_RESULTS',
					elementType: 'PANE',
					text: 'FORM_COMPLETED',
					htmlId: 'RESULTS_VIEWED',
				},
			});
		}

		// For each step of the cost calculator multistep insert the value of clicked element
		// in to the UI/UX tracker to the left of form for the appropriate step
		// (matched by data attribute name of step, and semi-matching htmlID of tracker part on left)
		function choiceTracker() {
			const formStep1 = document.querySelector("[data-name='form-step--systemType']");
			const formStep2 = document.querySelector("[data-name='form-step--homeSize']");
			const formStep3 = document.querySelector("[data-name='form-step--hvacFeatures']");
			const formStepArr = [formStep1, formStep2, formStep3];
			formStepArr.forEach((item) => {
				item.addEventListener('click', (event) => {
					const isButton = event.target.nodeName === 'BUTTON';
					if (!isButton ||
						event.target.innerHTML.indexOf('Next') !== -1 ||
						event.target.innerHTML.indexOf('Back') !== -1 ||
						event.target.innerHTML.indexOf('Submit') !== -1) {
						return;
					}
					if (item.dataset.name.indexOf('systemType') > -1) {
						document.querySelector('#systemType').classList.add('active');
						document.querySelector('#systemTypeTrack').innerHTML = event.target.innerHTML;
					} else if (item.dataset.name.indexOf('homeSize') > -1) {
						document.querySelector('#homeSize').classList.add('active');
						document.querySelector('#homeSizeTrack').innerHTML = event.target.innerHTML;
					} else if (item.dataset.name.indexOf('hvacFeatures') > -1) {
						document.querySelector('#hvacFeatures').classList.add('active');
						document.querySelector('#hvacFeaturesTrack').innerHTML = event.target.innerHTML;
					}
				});
			});
		}

		const costCalculator = document.querySelector('#costCalculatorForm');
		if (costCalculator) {
			choiceTracker();

			document.querySelectorAll('.brand-list__cta').forEach((item) => {
				item.addEventListener('click', () => {
					if (typeof window.tagular !== 'function') {
						return;
					}
					window.tagular('beam', {
						'@type': 'redventures.usertracking.v3.ElementClicked',
						webElement: {
							location: 'COST_CALCULATOR_PAGE',
							position: 'COST_CALCULATOR_FORM_RESULTS',
							elementType: 'LINK',
							text: item.dataset.tagularText,
							htmlId: 'COMPANY_CTA_LINK',
						},
						actionOutcome: 'INTERNALLINK',
					});
				});
			});

			// "Start over" button on final results page
			// Hides results and give user back control of form to change info and submit
			document.querySelector('.btn-start-over').addEventListener('click', (event) => {
				event.preventDefault();
				document.querySelector('#costCalculatorFinalResult').classList.add('hide-off-screen');
				document.querySelector('#costCalculatorForm').classList.remove('hide');
				document.querySelector('#costCalculatorForm').style.display = 'block';
				if (typeof window.tagular !== 'function') {
					return;
				}
				window.tagular('beam', {
					'@type': 'redventures.usertracking.v3.ElementClicked',
					webElement: {
						location: 'COST_CALCULATOR_PAGE',
						position: 'HERO',
						elementType: 'BUTTON',
						text: 'START_OVER',
						htmlId: 'START_OVER',
					},
					actionOutcome: 'INTERNALLINK',
				});
				// for theme block cost calculator remove add back choice tracker
				if (document.querySelector('.cost-calculator--acf .cost-calculator__choice-tracker.hide')) {
					document.querySelector('.cost-calculator--acf .cost-calculator__choice-tracker').classList.remove('hide');
				}
				// reset choice tracker values
				document.querySelectorAll('.cost-calculator__choice-tracker .choice').forEach((item) => {
					item.classList.remove('active');
				});
				document.querySelectorAll('.cost-calculator__choice-tracker .choice__answer').forEach((item) => {
					item.innerHTML = '-';
				});
				const ogSubheadStr = 'Get a free online estimate for your HVAC system.';
				document.getElementById('subheadEstimateResult').innerHTML = ogSubheadStr;
				document.querySelector('.cost-calculator__disclaimer').classList.add('hide');
				document.querySelector('#costCalculatorForm').innerHTML = '';
				costCalculatorExp.costCalculatorNoLeadForm();
				choiceTracker();
			});
		}

		// Fire ElementViewed Tagular event when cost calculator enters viewport
		const ccForm = document.querySelector('.cost-calculator-component');
		var observer;
		observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.intersectionRatio > 0 && entry.intersectionRatio < 2) {
					if (typeof window.tagular !== 'function') {
						return;
					}
					window.tagular('beam', {
						'@type': 'redventures.usertracking.v3.FormViewed',
						formContext: {
							formType: 'COST_CALCULATOR',
							formName: 'COST_CALCULATOR_FORM',
							formId: 'COST_CALCULATOR',
						},
					});
				}
			});
		});
		observer.observe(ccForm);
	});
})();

// Cost Calculator results component slider for recommended brand list
// Referencing HTML in wp-content/themes/furnacecompare/page-cost-calculator.php
(function ($) {
	const $costCalcResultsSlider = $('.js-cc-results-brand-list');

	if ($costCalcResultsSlider.length) {
		let sliderActive = false;

		function sliderInit() {
			if ($costCalcResultsSlider.length && !sliderActive) {
				setTimeout(function () {
					$('.js-cc-results-brand-list').slick({
						autoplay: true,
						arrows: true,
						prevArrow: '<div class=\"slick-prev slick-arrow\"></div>',
						nextArrow: '<div class=\"slick-next slick-arrow\"></div>',
						dots: true,
						mobileFirst: true,
						slidesToShow: 1,
						slidesToScroll: 1,
						center: true,
						infinite: false,
					});
				}, 1);
			}
		}
		sliderInit();
		sliderActive = true;
		$(window).resize(sliderInit);
	}
}(jQuery));



// WEBPACK FOOTER //
// ./assets/js/partials/cost-calculator.js